import React, { useState } from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core';
import { EditIcon } from 'components/CustomSVG';
import CustomerAddressForm from './CustomerAddressForm';


const CustomerAddresses = ({customer}) => {
  const {addresses, default_billing, default_shipping} = customer;

  const [openAddressForm, toggleAddressForm] = useState(false);
  const [editableAddress, setEditableAddress] = useState({});

  const billingAddress = addresses.find((address) => address.id == default_billing) || '';
  const shippingAddress = addresses.find((address) => address.id == default_shipping) || '';
  const additionalAddresses = addresses.filter((address) => address.id != default_billing && address.id != default_shipping);

  const Address = ({address}) => (
    <div className="flex-column">
      <div className="font-bold mb-3">{address.firstname} {address.lastname}</div>
      <div className="mb-2 ml-2">{address?.street ? address.street.join(', ') : ''}</div>
      <div className="mb-2 ml-2">{`${address.city}, ${address.region?.region}, ${address.postcode}`}</div>
      <div className="mb-2 ml-2">United States</div>
      <div className="mb-2 ml-2">Phone: {address.telephone}</div>
    </div>
  );

  return (
    <div>
      {!!addresses.length ?
        <Grid container spacing={5}>
          {default_billing == default_shipping && !!billingAddress &&
            <Grid item xs={12} md={6} lg={4}>
              <Card elevation={24} className="text-gray">
                <CardActions className="justify-between">
                  <Typography variant="h6" className="px-2 text-primary">
                    Default Billing/Shipping Address
                  </Typography>
                  <IconButton
                    title="Edit Address"
                    onClick={() => {
                      setEditableAddress(billingAddress);
                      toggleAddressForm(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </CardActions>
                <Divider />
                <CardContent>
                  <Address address={billingAddress} />
                </CardContent>
              </Card>
            </Grid>
          }
          {default_billing != default_shipping && !!billingAddress &&
            <Grid item xs={12} md={6} lg={4}>
              <Card elevation={24} className="text-gray">
                <CardActions className="justify-between">
                  <Typography variant="h6" className="px-2 text-primary">
                    Default Billing Address
                  </Typography>
                  <IconButton
                    title="Edit Address"
                    onClick={() => {
                      setEditableAddress(billingAddress);
                      toggleAddressForm(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </CardActions>
                <Divider />
                <CardContent>
                  <Address address={billingAddress} />
                </CardContent>
              </Card>
            </Grid>
          }
          {default_billing != default_shipping && !!shippingAddress &&
            <Grid item xs={12} md={6} lg={4}>
              <Card elevation={24} className="text-gray">
                <CardActions className="justify-between">
                  <Typography variant="h6" className="px-2 text-primary">
                    Default Shipping Address
                  </Typography>
                  <IconButton
                    title="Edit Address"
                    onClick={() => {
                      setEditableAddress(shippingAddress);
                      toggleAddressForm(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </CardActions>
                <Divider />
                <CardContent>
                  <Address address={shippingAddress} />
                </CardContent>
              </Card>
            </Grid>
          }
          {!!additionalAddresses.length &&
            <>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              {additionalAddresses.map((address, index) => {
                return (
                  <Grid item xs={12} md={6} lg={4} key={`address-${index}`}>
                    <Card elevation={24} className="text-gray">
                      <CardActions className="justify-between">
                        <Typography variant="h6" className="px-2 text-primary">
                          Additional Address {index + 1}
                        </Typography>
                        <IconButton
                          title="Edit Address"
                          onClick={() => {
                            setEditableAddress(address);
                            toggleAddressForm(true);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </CardActions>
                      <Divider />
                      <CardContent>
                        <Address address={address} />
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </>
          }
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => toggleAddressForm(true)}
            >
              Add New Address
            </Button>
          </Grid>
        </Grid>
        :
        <div>
          <p>Customer has no addresses.</p>
          <Button
            color="primary"
            variant="contained"
            onClick={() => toggleAddressForm(true)}
          >
            Add New Address
          </Button>
        </div>
      }
      <Dialog
        open={openAddressForm}
        onClose={() => {
          toggleAddressForm(false);
          setEditableAddress({});
        }}
        fullWidth
        maxWidth="sm"
      >
        <CustomerAddressForm
          customer={customer}
          editableAddress={editableAddress}
          toggleAddressForm={toggleAddressForm}
          setEditableAddress={setEditableAddress}
        />
      </Dialog>
    </div>
  );
};

export default CustomerAddresses;
